/**
 * Base css generation and global js logic.
 */

import './tailwind.tokens.css';

import $ from 'jquery';

require('jquery-once');

// @NOTE: This is a hack. I'm still not sure how to access webpack jQuery in an easy way from Drupal, so I expose this
// here and will check for existence in the JS files from the theme.
window.particle_jquery = $;

// Export global variables.
export default {
  // Demo only, remove in practice
  GLOBAL_CONSTANT: 'particle',
};
